import { render, staticRenderFns } from "./paymentMethodsTable.vue?vue&type=template&id=2d13fa33&lang=pug&"
import script from "./paymentMethodsTable.vue?vue&type=script&lang=js&"
export * from "./paymentMethodsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports